(function () {
    'use strict';

    a3_cabin_reports.directive('additionalTraining', additionalTraining);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name additionalTraining
    * @restrict E
    * @description
    *   Implementation of additional Training
    * @example
    *   Usage:
    *   <additional-training></additional-training>
    * @ngInject
    */
    function additionalTraining($uibModal) {
        function link(scope) {
        
            scope.filterTrainee = filterTrainee;
            scope.yesAdditional = yesAdditional;
            scope.noAdditional = noAdditional;
            scope.NeedsAdditionalTraining = false;
            scope.clearAdditionalNotes = clearAdditionalNotes;
            scope.remarksSelection = remarksSelection;

            scope.completeAdditional = completeAdditional;
            scope.continueAdditional = continueAdditional;
            scope.selectedTrainee.startAdditional = false;
            scope.initializeAdditional = initializeAdditional;
            scope.toggleAdditional = toggleAdditional;
            scope.selectedTrainee.continueAdditional = false;
            scope.openAdditionalModal = openAdditionalModal;
           
            function yesAdditional(trainee) {
                scope.selectedTrainee.NeedsAdditionalTraining = true;
                trainee.Session.NeedsAdditionalTraining = true;
                scope.CompleteAdditionalTraining = false;
                trainee.Session.CompleteAdditionalTraining = false;
                trainee.Session.UnderAdditionalTraining = false;
                scope.selectedTrainee.startAdditional = true;
                remarksSelection(trainee);            
            }

            function noAdditional(trainee) {
                scope.selectedTrainee.NeedsAdditionalTraining = false;
                trainee.Session.NeedsAdditionalTraining = false;
                scope.CompleteAdditionalTraining = false;
                trainee.Session.CompleteAdditionalTraining = false;
                trainee.Session.UnderAdditionalTraining = false;
                trainee.Session.AdditionalTrainingStatus = 'None';
                clearAdditionalNotes(trainee);
            }

            function clearAdditionalNotes(trainee) {
                scope.selectedTrainee.Session.AdditionalTrainingRemarks = '';
                trainee.Session.AdditionalTrainingRemarks = '';
            }

            function completeAdditional(trainee) {
                scope.selectedTrainee.NeedsAdditionalTraining  = false;
                trainee.Session.NeedsAdditionalTraining = false;
                scope.CompleteAdditionalTraining = true;
                trainee.Session.CompleteAdditionalTraining = true;
                trainee.Session.UnderAdditionalTraining = true;
        
                remarksSelection(trainee);            
            }

            function continueAdditional(trainee) {
                scope.selectedTrainee.NeedsAdditionalTraining = true;
                trainee.Session.NeedsAdditionalTraining = true;
                scope.CompleteAdditionalTraining = false;
                trainee.Session.CompleteAdditionalTraining = false;
                trainee.Session.UnderAdditionalTraining = true;

                remarksSelection(trainee);            
            }

            function filterTrainee(){
                return function(trainee) {
                    var showTrainee = true;
                    if(scope.selectedTrainee){ //individual grading view: filter selected
                        showTrainee = scope.selectedTrainee.CrewId == trainee.CrewId
                    }
                    return showTrainee;
                };
            }

            function remarksSelection(trainee){
                trainee.Session.AdditionalTrainingRemarks = scope.selectedTrainee.Session.AdditionalTrainingRemarks;    
            }

            function toggleAdditional(trainee){
                if(scope.selectedTrainee.continueAdditional){
                    continueAdditional(trainee);
                }
                else{
                    completeAdditional(trainee);
                }
            }

            function initializeAdditional(trainee){
                if(scope.selectedTrainee.startAdditional){
                    yesAdditional(trainee);
                }
                else{
                    noAdditional(trainee);
                }
            }

            function openAdditionalModal(userInput) {
                $uibModal.open({ 
                    templateUrl: 'views/Dialogs/dlgAdditionalTraining.html',
                    controller: 'AdditionalTrainingModalCtrl',
                    size: 'md',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {                      
                        retVal: function () {
                            return userInput;
                        },               
                        startAdd: userInput 
                    }
                });
            }
        }

        return {
            restrict: 'E',
            terminal: true,
            templateUrl: 'views/Training/additionalTraining.tpl.html',
            scope: false,
            link: link
        }
    }

})();
